import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useSelector } from 'react-redux';

const TableHeader = () => {
  const type = useSelector( state => state.type.typeIs );
  
   if(type === 'plan'){
     return (
       <>
        <TableRow>
           <TableCell>ID</TableCell> 
           <TableCell>DESCRIPCION</TableCell>
           <TableCell>FECHA</TableCell>  
           <TableCell>CREADOR</TableCell> 
           <TableCell>CREADO</TableCell> 
           <TableCell>MODIFICADOR</TableCell>
           <TableCell>MODIFICADO</TableCell>
           <TableCell>ACTIVO</TableCell>
           <TableCell>ACCION</TableCell> 
           <TableCell>ADJUNTO</TableCell>
        </TableRow>   
        </> 
          )
    }
    if(type === 'news') {
      return(
        <TableRow>
           <TableCell>ID</TableCell> 
           <TableCell>TITULO</TableCell> 
           <TableCell>CONTENIDO</TableCell> 
           <TableCell>CREADO</TableCell>
           <TableCell>CREADOR</TableCell>
           <TableCell>MODIFICADOR</TableCell>
           <TableCell>MODIFICADO</TableCell>
           <TableCell>ACTIVO</TableCell>
           <TableCell>ACCION</TableCell>   
           <TableCell>ADJUNTO</TableCell>
        </TableRow>       
      ) 
    }       
}

export default TableHeader;